import { FC } from 'react'
import { Player as RawPlayer } from '../../../__legacy__/components/platform/explore/common/MediaPreview'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { PlayerWrapper } from '../primitives'

export const ArpPlayer: FC<{ media: IArpMedia }> = ({ media }) => (
  <PlayerWrapper.Root>
    <PlayerWrapper.Content>
      <RawPlayer index={media.id} type={media.type} autoPlay={false} />
    </PlayerWrapper.Content>
  </PlayerWrapper.Root>
)
